import { render } from "./AppEncapsulated.vue?vue&type=template&id=6205cb54"
import script from "./AppEncapsulated.vue?vue&type=script&lang=js"
export * from "./AppEncapsulated.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"AppEncapsulated.vue"]])

export default __exports__